import request from './httpService';

const BASE = '/insurance-provider';

const search = (q = '', signal) =>
  request({ method: 'GET', url: `${BASE}/search`, params: { q }, signal });

const getAll = () =>
  request({ method: 'GET', url: BASE });

const create = (data) =>
  request({ method: 'POST', url: BASE, data });

const update = (id, data) =>
  request({ method: 'PUT', url: `${BASE}/${id}`, data });

const deactivate = (id) =>
  request({ method: 'DELETE', url: `${BASE}/${id}` });

export const InsuranceProviderService = { search, getAll, create, update, deactivate };
